/**
 * Styled Components - Created by cazarez on 07/02/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1600px;
  margin: 0 auto;
`

export const ContainerMobile = styled.div`
`

export const Row = styled.div`
  display: flex;
  gap: var(--spacing-24);
`

export const Column = styled.div`
  height: 144px;
`

export const Text = styled.div`
  color: #fff;
`

export const ComplianceLogos = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: var(--spacing-24);
  max-width: 100px;
  a {
    padding: 0 var(--spacing-8);
  }
  img {
    width: 100%;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    flex-flow: row;
    justify-content: center;
    align-items: center;
    margin-top: var(--spacing-32);
    padding-top: var(--spacing-24);
    justify-content: space-between;
    padding-inline: var(--spacing-24);
    border-top: var(--border-regular) solid var(--neutral-secondary);
    a {
      padding: unset;
      max-width: 100px;
      width: 100%;
    }
    .short {
      max-width: var(--spacing-64);
    }
  }
`

export const RewardLogo = styled.div`
  transform: scale(0.9);
  transform-origin: top left;
  .yotpo-display-wrapper {
    height: auto !important;
  }
  @media (max-width: 768px) {
    transform-origin: top center;
    margin-top: var(--spacing-24);
    transform: scale(0.7);
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ContactAndLinks/styledComponents.tsx